// theme/src/gift-wrap/src/packaging/components/NameField.jsx
import React from 'react';
import { getRegexFromRestrictions } from '../../utilities/getRegexFromRestrictions';
import { NAME_MAX_LENGTH } from '../selection';
import styles from '../packaging.module.css';

// Same rule as today's gift bag text: letters, digits and spaces only (PersonalisationText/useViewModel.js).
const ALLOWED = new RegExp(
  `[${getRegexFromRestrictions({ allowLetters: true, allowNumbers: true, allowSpaces: true, allowSymbols: false, allowedTextCase: 'MIXED' })}]`,
  'g'
);

/** @param {string} value @returns {string} */
export const sanitiseName = (value) => (value.match(ALLOWED) || []).join('').slice(0, NAME_MAX_LENGTH);

/** A labelled text input with a character counter. Defaults to the gift bag / keepsake name rules. */
export function NameField({
  id,
  label,
  helper = '',
  value,
  onChange,
  maxLength = NAME_MAX_LENGTH,
  placeholder = 'Enter Name',
  clean = sanitiseName
}) {
  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.fieldLabel}>
        {label}
      </label>
      {helper && <span className={styles.helper}>{helper}</span>}
      {/* The input's right padding follows the counter's width (ALBAU-896). */}
      <div className={styles.inputWrap} style={{ '--counter-chars': String(maxLength).length }}>
        <input
          id={id}
          type="text"
          className={styles.input}
          value={value}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={(e) => onChange(clean(e.target.value))}
        />
        <span className={styles.counter}>
          {value.length}/{maxLength}
        </span>
      </div>
    </div>
  );
}
